const CollectionSliderModule = (function() {
  const DEFAULT_OPTIONS = {
    slidesPerRow: 4,
    columnGap: 16,
    buttonOffset: 0
  };

  function getBreakpoints(slidesPerRow) {
    return {
      320: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 16
      },
      480: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 16
      },
      768: {
        slidesPerView: Math.min(3, slidesPerRow),
        slidesPerGroup: Math.min(3, slidesPerRow),
        spaceBetween: 48
      },
      1024: {
        slidesPerView: slidesPerRow,
        slidesPerGroup: slidesPerRow,
        spaceBetween: 48
      }
    };
  }

  class CollectionSlider {
    constructor(element, options = {}) {
      this.element = element;
      this.options = { ...DEFAULT_OPTIONS, ...options };
      this.swiper = null;
      this.init();
    }

    init() {
      this.setupContainer();
      this.initializeSwiper();
      this.bindEvents();
    }

    setupContainer() {
      const slider = this.element.querySelector('.collection-list-slider');
      if (!slider) return;

      if (!slider.querySelector('.swiper-wrapper')) {
        const items = Array.from(slider.querySelectorAll('.collection-list-slider__item'));
        const wrapper = document.createElement('div');
        wrapper.className = 'swiper-wrapper';

        items.forEach(item => {
          item.classList.add('swiper-slide');
          wrapper.appendChild(item);
        });

        slider.insertBefore(wrapper, slider.firstChild);
      }
    }

    initializeSwiper() {
      const container = this.element.querySelector('.collection-list-slider');
      if (!container) return;

      const config = {
        scrollbar: {
          el: this.element.querySelector('.swiper-scrollbar'),
          hide: false,
          draggable: true
        },
        breakpoints: getBreakpoints(this.options.slidesPerRow),
        roundLengths: true,
        speed: 500,
        updateOnImagesReady: true,
        navigation: {
          nextEl: this.element.querySelector('.swiper-button-next'),
          prevEl: this.element.querySelector('.swiper-button-prev')
        },
        on: {
          init: (swiper) => {
            this.positionButtons();
            this.updateAriaLabels();
          },
          slideChange: () => {
            this.updateAriaLabels();
          }
        }
      };

      this.swiper = new Swiper(container, config);
    }

    bindEvents() {
      window.addEventListener('resize', this.handleResize.bind(this));
      
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && this.swiper) {
              this.swiper.update();
            }
          });
        },
        { threshold: 0.1 }
      );
      
      observer.observe(this.element);
    }

    handleResize() {
      if (this.swiper) {
        this.swiper.update();
        this.positionButtons();
      }
    }

    positionButtons() {
      const buttons = this.element.querySelectorAll('.swiper-button-next, .swiper-button-prev');
      buttons.forEach(button => {
        button.style.top = `${this.options.buttonOffset}px`;
        button.style.transform = 'none';
      });
    }

    updateAriaLabels() {
      if (!this.swiper) return;
      
      const nextButton = this.element.querySelector('.swiper-button-next');
      const prevButton = this.element.querySelector('.swiper-button-prev');
      
      if (nextButton) {
        nextButton.setAttribute('aria-label', 'Next collection');
        nextButton.setAttribute('aria-disabled', !this.swiper.isEnd ? 'false' : 'true');
      }
      
      if (prevButton) {
        prevButton.setAttribute('aria-label', 'Previous collection');
        prevButton.setAttribute('aria-disabled', !this.swiper.isBeginning ? 'false' : 'true');
      }
    }

    update() {
      if (this.swiper) {
        this.swiper.update();
        this.positionButtons();
      }
    }

    destroy() {
      if (this.swiper) {
        this.swiper.destroy();
        this.swiper = null;
      }
    }
  }

  function init(selector = '.collection-list', options = {}) {
    const elements = document.querySelectorAll(selector);
    const instances = [];

    elements.forEach(element => {
      const dataOptions = {
        slidesPerRow: parseInt(element.dataset.collPerRow) || DEFAULT_OPTIONS.slidesPerRow,
        columnGap: parseInt(element.dataset.columnGap) || DEFAULT_OPTIONS.columnGap,
        buttonOffset: parseInt(element.dataset.buttonOffset) || DEFAULT_OPTIONS.buttonOffset
        
      };

      const mergedOptions = { ...dataOptions, ...options };
      
      instances.push(new CollectionSlider(element, mergedOptions));
    });

    return instances;
  }
  return {
    init,
    DEFAULT_OPTIONS
  };
})();

if (typeof module !== 'undefined' && module.exports) {
  module.exports = CollectionSliderModule;
} else if (typeof define === 'function' && define.amd) {
  define([], function() { return CollectionSliderModule; });
} else {
  window.CollectionSliderModule = CollectionSliderModule;
}